import { controls, currencyToNumber, grouped } from "../../controls";

const rpsl22 = {
  label: "Minority Disbursement SLBC",
  starting: true,
  url: "rpsl22",
  pageLabel: "Minority Disbursement SLBC",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "filter", label: "Reporting Season", star: true }),
    ...controls.autoComplete({ tab: "filter", name: "manual_report_master_code", width: "col-sm-2", controlType: "ManualReportMaster" }),
    ...controls.displayText({ tab: "filter", label: "" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Minority Disbursement SLBC",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait"
    },
    textReportProps: {
      'slbc': {
        filename: `Minority Disbursement.txt`,
        format: {},
        separator: "|"
      },
    },

    displayColumns: [
      {
        Header: "State Code",
        accessor: "slbc_state_no",

      },
      {
        Header: "District Code",
        accessor: "slbc_district_no",

      },
      {
        Header: "Block Code",
        accessor: "slbc_block_code",

      },
      {
        Header: "Christians No. from 1st April to end of Current Quarter",
        accessor: "christians_no",
      },
      {
        Header: "Christians Amount from 1st April to end of Current Quarter",
        accessor: "christians_amt",
        type: "currency"
      },
      {
        Header: "Muslims No. from 1st April to end of Current Quarter",
        accessor: "muslims_no",
      },
      {
        Header: "Muslims Amount from 1st April to end of Current Quarter",
        accessor: "muslims_amt",
        type: "currency"
      },
      {
        Header: "Buddhists No. from 1st April to end of Current Quarter",
        accessor: "buddhists_no",
      },
      {
        Header: "Buddhists Amount from 1st April to end of Current Quarter",
        accessor: "buddhists_amt",
        type: "currency"
      },
      {
        Header: "Sikhs No. from 1st April to end of Current Quarter",
        accessor: "sikhs_no",
      },
      {
        Header: "Sikhs Amount from 1st April to end of Current Quarter",
        accessor: "sikhs_amt",
        type: "currency"
      },
      {
        Header: "Zorastrians No. from 1st April to end of Current Quarter",
        accessor: "zorastrians_no",
      },
      {
        Header: "Zorastrians Amount from 1st April to end of Current Quarter",
        accessor: "zorastrians_amt",
        type: "currency"
      },
      {
        Header: "Jains No. from 1st April to end of Current Quarter",
        accessor: "jains_no",
      },
      {
        Header: "Jains Amount from 1st April to end of Current Quarter",
        accessor: "jains_amt",
        type: "currency"
      },
      {
        Header: "Total No. from 1st April to end of Current Quarter",
        accessor: "total_no",
      },
      {
        Header: "Total Amount from 1st April to end of Current Quarter",
        accessor: "total_amt",
        type: "currency"
      },
      
    ]
  }
};

export default rpsl22;